export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-10.dd888bb1.svg";